import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import {
	Segment, Container, Message, Form, Button, Input
} from 'semantic-ui-react';
import { t } from "../../../i18n";
import FormComponent from '../../containers/formcomponent';

function mapStateToProps(state) {
	return {
		verification: state.sendEmailVerificationMail,
	};
}

class ResendEmailVerification extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			showSuccess: false,
			...this.state,
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.verification !== this.props.verification) {
			let verification = this.props.verification;
			this.validateForm(verification, () => {
				if (verification.data) {
					this.setState({ message: verification.data.message, showSuccess: true })
				}
			})
		}
	}

	callSendEmailVerificationMail() {
		this.props.actions.sendEmailVerificationMail({
			email: this.state.email,
		});
	}


	render() {
		return (
			<Segment basic>
				<Container>
					<Segment className="loginSegment" style={{ minWidth: "40%", margin: 'auto' }} basic>
						<Form onSubmit={this.handleSubmitForm.bind(this, () => this.callSendEmailVerificationMail())}
							error={this.state.showErrors} success={this.state.showSuccess}>
							<Form.Field error={this.state.formErrorsKeys.email}>
								<label>{t("emailAddress")}</label>
								<Input required
									name='email'
									type='email'
									onChange={this.handleValueChange.bind(this)}
									value={this.state.email}
								/>
							</Form.Field>
							<Message error
								header={this.state.formErrorsMessage}
								list={this.state.formErrors}
							/>
							<Message success
								header={this.state.message}
							/>
							<Button primary type="submit" disabled={this.state.disabled}>{t("Send")}</Button>
						</Form>
					</Segment>
				</Container>
			</Segment>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResendEmailVerification)
